import { forwardRef } from "react";

import { cx } from "@/utils";
import Typography from "@components/Typography";

import styles from "./SwitchToggle.module.css";

export type SwitchToggleProperties = React.HTMLProps<HTMLInputElement> & {
  block?: boolean;
  label?: string | React.ReactNode;
  errorMessage?: never;
  reverse?: boolean;
};

const SwitchToggle = forwardRef<HTMLInputElement, SwitchToggleProperties>(
  (
    { label, block, errorMessage: _errorMessage, reverse, className, ...props },
    ref
  ) => {
    return (
      <label
        className={cx(
          styles.switchToggle,
          {
            [styles.block]: block,
            [styles.reverse]: reverse,
          },
          className
        )}
      >
        {label && (
          <Typography variant="body-2" className={styles.label} margin="none">
            {label}
          </Typography>
        )}
        <input type="checkbox" role="switch" {...props} ref={ref} />
      </label>
    );
  }
);

SwitchToggle.displayName = "SwitchToggle";

export default SwitchToggle;
